module.exports = __webpack_public_path__ + "img/Qumulex.500898e4.svg";